export default __webpack_public_path__ + "static/media/mosaic4.1646471f.png";